import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { AppConfigService } from '../../shared/services/app-config.service';
import { LoaderService } from '../../shared/services/loader.service';
import { AlertsHandlerService } from '../../shared/services/alerts-handler.service';
import { BaseDataService } from '../../shared/services/base-data.service';
import { Observable } from 'rxjs';
import { PagedResponse } from '../../shared/models/paged-response.model';
import { AddScheduleJobRequest } from '../models/add-schedulejob.request';
import { ScheduleJob } from '../models/schedulejob.model';
import { UserLoggedinAuditData } from '../models/user-loggedin-audit-data.model';
import { ISFUploadAuditData } from '../models/isf-upload-audit-data.model';
import { CustomerPacketAuditData } from '../models/customer-packet-audit-data.model';
import { DocManagementAuditData } from '../models/doc-management-audit-data.model';
import { PrivateTrackerSearchAuditData } from '../models/private-tracker-search-audit-data.model';
import { GraphParameter } from '../models/graph-parameter.model';
import { FTPFileUpload } from '../models/ftp-fileupload.model';
import { FTPFileUploadParameter } from '../models/ftp-fileupload-parameter.model';
import { CustomerPacketByStaffUser } from '../models/customer-packet-by-staffuser.model';
import { TrackAndTraceAuditData } from '../models/trackandtrace-data.model';
import { Company } from 'src/app/processing/models/company';


@Injectable({  providedIn: 'root'
} 
)
export class AdminDashboardDataService extends BaseDataService {

    constructor(
    protected httpClient: HttpClient,
    protected appConfigService: AppConfigService,
    protected loaderService: LoaderService,
    protected alertsHandlerService: AlertsHandlerService
  ) {
    super(httpClient, appConfigService, loaderService, alertsHandlerService);
  }

    // public getUserList(): Observable<PagedResponse<User>> {
    //  return this.get<PagedResponse<User>>('admindashboard/users/list');
    // }

    public getScheduleJobList(): Observable<PagedResponse<ScheduleJob>> {
      return this.get<PagedResponse<ScheduleJob>>('admindashboard/schedulejob/list');
    }

    public updateScheduleJob(request: AddScheduleJobRequest, jobId: number): Observable<object> {
      return this.put<object>('admindashboard/schedulejob/' + jobId, request);
    }

    public getUserLoggedinAuditDataList(filter: GraphParameter): Observable<PagedResponse<UserLoggedinAuditData>> {
      const params = new HttpParams()
        .set('GraphType', filter.GraphType)
        .set('DateFrom', filter.DateFrom.toDateString())
        .set('DateTo', filter.DateTo.toDateString());
      return this.get<PagedResponse<UserLoggedinAuditData>>('admindashboard/userLoggedinAuditData/list', { params });
    }

    public getIsfUploadAuditDataList(filter: GraphParameter): Observable<PagedResponse<ISFUploadAuditData>> {
      const params = new HttpParams()
        .set('GraphType', filter.GraphType)
        .set('DateFrom', filter.DateFrom.toDateString())
        .set('DateTo', filter.DateTo.toDateString());
      return this.get<PagedResponse<ISFUploadAuditData>>('admindashboard/isfUploadAuditData/list', { params });
    }

    public getCustomerPacketAuditDataList(filter: GraphParameter): Observable<PagedResponse<CustomerPacketAuditData>> {
      const params = new HttpParams()
        .set('GraphType', filter.GraphType)
        .set('DateFrom', filter.DateFrom.toDateString())
        .set('DateTo', filter.DateTo.toDateString());
      return this.get<PagedResponse<CustomerPacketAuditData>>('admindashboard/customerPacketAuditData/list', { params });
    }

    public getDocManagementAuditDataList(filter: GraphParameter): Observable<PagedResponse<DocManagementAuditData>> {
      const params = new HttpParams()
        .set('GraphType', filter.GraphType)
        .set('DateFrom', filter.DateFrom.toDateString())
        .set('DateTo', filter.DateTo.toDateString());
      return this.get<PagedResponse<DocManagementAuditData>>('admindashboard/docManagementAuditData/list', { params });
    }

    public getPrivateTrackerSearchAuditDataList(filter: GraphParameter): Observable<PagedResponse<PrivateTrackerSearchAuditData>> {
      const params = new HttpParams()
        .set('GraphType', filter.GraphType)
        .set('DateFrom', filter.DateFrom.toDateString())
        .set('DateTo', filter.DateTo.toDateString());
      return this.get<PagedResponse<PrivateTrackerSearchAuditData>>('admindashboard/privateTrackerSearchAuditData/list', { params });
    }
    public getFTPFileUploadList(filter: FTPFileUploadParameter): Observable<PagedResponse<FTPFileUpload>> {
      // const params = this.toHttpParams(myListFilter);
      const params = new HttpParams()
        .set('FileName', filter.FileName)
        .set('FromDate', filter.FromDate.toDateString())
        .set('ToDate', filter.ToDate.toDateString());
      return this.get<PagedResponse<FTPFileUpload>>('admindashboard/ftpFileUpload/list', { params });
    }

    public getCustomerPacketByStaffUser(filter: GraphParameter): Observable<PagedResponse<CustomerPacketByStaffUser>> {
      const params = new HttpParams()
        .set('GraphType', filter.GraphType)
        .set('DateFrom', filter.DateFrom.toDateString())
        .set('DateTo', filter.DateTo.toDateString());
      return this.get<PagedResponse<CustomerPacketByStaffUser>>('admindashboard/customerPacketbyStaffUser/list', { params });
    }

  public getTrackAndTraceDataList(filter: GraphParameter): Observable<PagedResponse<TrackAndTraceAuditData>> {
      const params = new HttpParams()
        .set('GraphType', filter.GraphType)
        .set('DateFrom', filter.DateFrom.toDateString())
        .set('DateTo', filter.DateTo.toDateString());
      return this.get<PagedResponse<TrackAndTraceAuditData>>('admindashboard/trackAndTraceAuditData/list', { params });
    }
    public getCompanies(): Observable<Company[]>{
      return this.get<Company[]>('Processing/Companies')
    }
// public getTerms(companyCode: string): Observable<string> {
//   return this.httpClient.get(`/api/Processing/Terms/${companyCode}`, { responseType: 'text' });
// }

// public saveTerms(companyCode: string, htmlContent: string): Observable<string> {
//   return this.httpClient.post(`/api/Processing/Terms/${companyCode}`, htmlContent, {
//     responseType: 'text'
//   });
// }

public getTerms(companyCode: string): Observable<string> {
  return this.get<string>(`Processing/Terms/${companyCode}`, {
    params: new HttpParams(),
    responseType: 'text'
  } as any);
}
// public saveTerms(companyCode: string, htmlContent: string): Observable<string> {
//   return this.post<string>(`Processing/Terms/${companyCode}`, htmlContent, true, {
//     headers: new HttpHeaders({ 'Content-Type': 'text/plain' }),
//     responseType: 'text' as 'json'  // due to Angular typings workaround
//   });
// public saveTerms(companyCode: string, htmlContent: string): Observable<string> {
//   return this.post<string>(
//     `Processing/Terms/${companyCode}`,
//     htmlContent,
//     true,
//     { headers: { 'Content-Type': 'text/plain' }, responseType: 'text' as 'json' } 
//   );
public saveTerms(companyCode: string, htmlContent: string): Observable<string> {
  return this.post<string>(
    `Processing/Terms/${companyCode}`,
    htmlContent,
    true,
    {
      headers: { 'Content-Type': 'text/plain' },
      responseType: 'text'
    }
  );
}
}


